import { render, staticRenderFns } from "./expoBuilder.vue?vue&type=template&id=22288ad1&scoped=true&"
import script from "./expoBuilder.vue?vue&type=script&lang=js&"
export * from "./expoBuilder.vue?vue&type=script&lang=js&"
import style0 from "./expoBuilder.vue?vue&type=style&index=0&id=22288ad1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22288ad1",
  null
  
)

export default component.exports